<template>
    <ul class="filter" v-if="!hideFilter">
        <li class="filter__item" v-if="tags.length > 0">
            <label for="tagFilter" class="sr-only">{{ dictionary.DefaultTag }}</label>
            <select id="tagFilter" v-model="tag" :disabled="isLoading">
                <option value="All">{{ dictionary.DefaultTag }}</option>
                <option v-for="tagItem in tags" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                    }}</option>
            </select>
        </li>
    </ul>
    <ul class="articles-list__items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" class="article-item__link">
                    <div class="article-item__inner">
                        <div :class="['article-item__image']">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-item__text">
                            <p class="article-item__tag">{{ article.Tag }}</p>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-list__cta">
        <div v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading" class="articles-list__load-more">
                {{ dictionary.LoadMore }}
            </a>
        </div>
    </div>
</template>


<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesApi/getArticles";
const defaultTag = "All"

export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    props: ['articlesNodeId', 'pageSize', 'hideFilter'],
    data() {
        return {
            dictionary: [],
            tags: [],
            articles: [],
            totalArticles: 0,
            page: 1,
            isLoading: false,
            hasLoadedInitials: false,
            isResetting: false,
            activeTags: []
        };
    },
    mixins: [
        bindRoute({
            tag: defaultTag,
        }),
    ],
    watch: {
        tag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
    },
    mounted() {
        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(itemsToSkip, pageSize) {
            const vm = this,
                cultureCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                cultureCode: cultureCode,
                itemsToSkip: itemsToSkip,
                pageSize: pageSize
            };

            if (vm.tag != defaultTag) {
                object.tag = vm.tag;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.tags = data.Facets.Tags;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.tag != defaultTag;
        }
    },
};
</script>